import {AfterContentInit, Component, ContentChildren, EventEmitter, Input, Output, QueryList, ViewEncapsulation} from '@angular/core';
import {AnalyticsService} from '@utils/services/analytics/analytics.service';
import {SwipeDirection, TabComponent} from '@shared/modules/shared-tabs/components/tab.component';
import {ITabChangeEvent} from '@shared/modules/shared-tabs/models/tab-change-event';

@Component({
  selector: 'app-tab-group',
  templateUrl: 'tab-group.component.html',
  styleUrls: ['tab-group.component.scss'],
})
export class TabGroupComponent implements AfterContentInit {

  @ContentChildren(TabComponent) public tabs: QueryList<TabComponent>;
  @Input() public sendPageViewOnTabChange = false;
  @Input() public allowSwipe = true;
  @Output() public activeTabChange = new EventEmitter<ITabChangeEvent>();
  private selectedIndex = 0;
  private selectedTab: TabComponent = null;

  constructor( private analyticsService: AnalyticsService ) {}

  public ngAfterContentInit(): void {
    // get all active tabs
    const activeTabs = this.tabs.filter(t => t.active);
    if (this.allowSwipe) {
      this.tabs.forEach((tab) => tab.swipe.subscribe(this.swipe.bind(this)));
    }
    this.tabs.changes.subscribe(
      () => this.selectTab(this.selectedIndex, false)
    );
    // if there is no active tab set, activate the first
    if (activeTabs.length === 0) {
      this.selectTab(0);
    }
  }

  public selectTab(tabIndex: number, triggerPageView = true): void {
    const tab = this.tabs.get(tabIndex);
    if (!tab) {
      return;
    }
    this.tabs.forEach(t => t.active = false);
    const initialChange = !this.selectedTab;
    tab.active = true;
    this.selectedTab = tab;
    if (this.selectedIndex !== tabIndex) {
      this.activeTabChange.emit({ initialChange, activeTab: tab });
    }
    this.selectedIndex = tabIndex;
    if (!initialChange && triggerPageView) {
      this.sendPageView();
    }
  }

  private swipe(direction: SwipeDirection): void {
    if (direction === SwipeDirection.Left && this.selectedIndex < this.tabs.length) {
      this.selectedIndex++;
    } else if (direction === SwipeDirection.Right && this.selectedIndex > 0) {
      this.selectedIndex--;
    }
    this.selectTab(this.selectedIndex);
  }

  private sendPageView(): void {
    if (!this.sendPageViewOnTabChange) {
      return;
    }
    const searchParams = new URLSearchParams();
    searchParams.set('tab', encodeURIComponent(this.selectedTab?.title));
    this.analyticsService.sendPageView({ queryParams: searchParams});
  }
}
